import axios from "axios";
import { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import Dropdown from "react-bootstrap/Dropdown";
import "./authorQues.css";

import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";
import QuestionInput from "./component/QuestionInput";
import DropdownMenu from "./component/Dropdown";

import { validateFile, validateThumbnail } from "../../utils/helper";
import { GlobalContext } from "../../context/GlobalState";
import { FieldInput } from "./component/FieldInput";
import { QuestionTypes } from "../Questions/constant";

const OBJECTIVE_LABELS = {
  mcq: "MCQ",
  mmcq: "MMCQ",
  oneword: "One Word",
  correctstatement: "True False",
  fillup: "Fill in the Blanks",
};

const COMPETENCY_LABELS = {
  descriptive: "HOTS Question",
  "assertion-reasoning": "Assertion and Reasoning",
};

const ASSERTION_REASONING_OPTIONS_HINDI = [
  {
    value:
      "(a) कथन और कारण दोनों सत्य हैं, तथा कारण कथन की सही व्याख्या करता है।",
    optionId: "op1",
  },
  {
    value:
      "(b) कथन और कारण दोनों सत्य हैं, लेकिन कारण कथन की सही व्याख्या नहीं करता है।",
    optionId: "op2",
  },
  {
    value: "(c) कथन सत्य है, लेकिन कारण असत्य है।",
    optionId: "op3",
  },
  {
    value: "(d) कथन और कारण दोनों असत्य हैं।",
    optionId: "op4",
  },
];

const ASSERTION_REASONING_OPTIONS = [
  {
    value:
      "(a) Both assertion and reason are true, and the reason is the correct explanation of the assertion.",
    optionId: "op1",
  },
  {
    value:
      "(b) Both assertion and reason are true, but the reason is not the correct explanation of the assertion.",
    optionId: "op2",
  },
  {
    value: "(c) Assertion is true, but reason is false.",
    optionId: "op3",
  },
  {
    value: "(d) Both assertion and reason are false.",
    optionId: "op4",
  },
];

const DIFFICULTY_LABELS = {
  easy: "Easy",
  intermediate: "Intermediate",
  hard: "Hard",
};

const COGNITIVE_LABELS = {
  knowledge: "Knowledge",
  understanding: "Understanding",
  application: "Application",
  analysis: "Analysis",
};

const VISIBILITY_LABELS = {
  private: "Private",
  publicForSchool: "Public For School",
  publicForAll: "Public For All",
};

const FIELD_LIMITS = {
  mcq: 4,
  mmcq: 4,
  oneword: 1,
  fillup: 10,
  correctstatement: 2,
  "assertion-reasoning": 4,
  descriptive: 1,
};

export default function AuthorQues({
  selSubjectId,
  selChapterId,
  selTopicId,
  selSectionId,
  handleRemoveClickCard,
  index,
  initial,
  setArrQues,
  setReviewQuestion,
  checkreview,
  topicsSel,
  assessmentType = "objective",
  isTopic = true,
  resources = false,
}) {
  const alert = useAlert();
  const [inputList, setInputList] = useState([]);
  const chapId = useParams()?.chapterId;
  const [questionText, setQuestionText] = useState("");
  const [assertText, setAssertText] = useState("");
  const [reasonText, setReasonText] = useState("");
  const [explanation, setExplanation] = useState("");
  const [authorQuestionFormData, setAuthorQuestionFormData] = useState(
    new FormData(),
  );
  const [correctAnswer, setCorrectAnswer] = useState({});
  const [questionType, setQuestionType] = useState("Choose Question Type");
  const [difficulty, setDifficulty] = useState("Difficulty");
  const [cognitive, setCognitive] = useState("Cognitive");
  const [language, setLanguage] = useState("English");
  const [topic, setTopic] = useState({ name: "Topic", id: "" });
  const [visible, setVisible] = useState("Visible To");
  const [authorQuestiontMessage, setAuthorQuestiontMessage] = useState("");
  const [marks, setMarks] = useState(0);
  const [authorQuesContentLoader, setAuthorQuesContentLoader] = useState(false);
  const { userDetails } = useContext(GlobalContext);

  const chapterId = useMemo(() => {
    if (typeof selChapterId === "string") return [selChapterId];
    return selChapterId;
  }, [selChapterId]);
  const topicId = selTopicId;
  const subjectId = selSubjectId;
  const sectionId = selSectionId;
  const authToken = localStorage.getItem("authToken");

  const questionTypes = useMemo(() => {
    if (assessmentType === "competency") return COMPETENCY_LABELS;
    return OBJECTIVE_LABELS;
  }, [assessmentType]);

  const hideAddFieldButton = useMemo(() => {
    if (questionType === "Choose Question Type") return true;
    return inputList.length >= FIELD_LIMITS[questionType];
  }, [questionType, inputList]);
  // handle input change
  const handleInputChange = (index, id, name, value) => {
    const list = [...inputList];
    list[index][name] = value;
    list[index]["optionId"] = id;
    setInputList(list);
  };

  const uploadFile = (e, name, file) => {
    setAuthorQuesContentLoader(true);
    const validateOnly =
      questionType === QuestionTypes.DESCRIPTIVE && name === "questionImg"
        ? ["audio", "video", "image"]
        : ["image"];
    if (validateFile(file, validateOnly)) {
      authorQuestionFormData.append(name, file);
      setAuthorQuestionFormData(authorQuestionFormData);
      setAuthorQuesContentLoader(false);
      alert.success("Question Media Uploaded");
    } else {
      e.target.value = null;
      setAuthorQuesContentLoader(false);
      alert.error("Please select valid file");
    }
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { optionId: "", value: "" }]);
  };

  const handleSelect1 = (e) => {
    setQuestionType(e);
    switch (e) {
      case "descriptive":
        setInputList([{ optionId: "", value: "" }]);
        break;
      case "assertion-reasoning":
        language.toLowerCase() === "hindi"
          ? setInputList(ASSERTION_REASONING_OPTIONS_HINDI)
          : setInputList(ASSERTION_REASONING_OPTIONS);
        break;
      default:
        setInputList([]);
        break;
    }
  };
  useEffect(() => {
    if (questionType !== "assertion-reasoning") return;
    language.toLowerCase() === "hindi"
          ? setInputList(ASSERTION_REASONING_OPTIONS_HINDI)
          : setInputList(ASSERTION_REASONING_OPTIONS);
  },[language]);
  const handleSelect2 = (e) => {
    setDifficulty(e);
  };
  const handleSelect3 = (e) => {
    setCognitive(e);
  };
  const handleSelect4 = (e) => {
    setVisible(e);
  };

  const handleCorrectAnswer = (e) => {
    const [id] = e.target.id.split("_");
    if (!e.target.checked) return;
    if (["mcq", "correctstatement"].includes(questionType)) {
      setCorrectAnswer({ [questionType]: id });
    } else if (["assertion-reasoning"].includes(questionType)) {
      console.log("Explanation", explanation);
      setCorrectAnswer({ [questionType]: { option: id, explanation } });
    } else {
      setCorrectAnswer({
        [questionType]: [
          ...(correctAnswer[questionType] ? correctAnswer[questionType] : []),
          id,
        ],
      });
    }
  };
  const handleSubmit = async () => {
    const isFillUp = ["oneword", "fillup", "descriptive"].includes(
      questionType,
    );

    if (chapterId.length > 1 && !resources) {
      alert.error("You cannot add question as you selected multiple chapter");
      return;
    }
    if (isFillUp) {
      inputList.forEach((x) => {
        if (correctAnswer[questionType]) {
          correctAnswer[questionType].push({
            blankId: x.optionId,
            answer: x.value,
          });
          setCorrectAnswer(correctAnswer);
        } else {
          correctAnswer[questionType] = [
            { blankId: x.optionId, answer: x.value },
          ];
          setCorrectAnswer(correctAnswer);
        }
      });
    }
    setAuthorQuesContentLoader(true);

    if (
      ["mmcq", "mcq", "assertion-reasoning"].includes(questionType) &&
      inputList.length < 4
    ) {
      alert.error("Please Create four options");
      setAuthorQuestionFormData(new FormData());
      return null;
    }
    if (questionType === "correctstatement" && inputList.length < 2) {
      alert.error("Please Create two options");
      setAuthorQuesContentLoader(false);
      return null;
    }
    if (!isFillUp && questionType != "Choose Question Type") {
      let c = 0;
      inputList.forEach((x) => {
        if (x.value === "") c = c + 1;
      });
      if (c > 0) {
        alert.error(`Please fill ${c} more field`);
        setAuthorQuesContentLoader(false);
        return null;
      }
    }

    if (
      ["mcq", "correctstatement", "mmcq", "assertion-reasoning"].includes(
        questionType,
      )
    ) {
      if (correctAnswer[questionType] === undefined) {
        alert.error("Choose one Option");
        setAuthorQuesContentLoader(false);
        return null;
      }
    }
    if (isFillUp && questionType != "Choose Question Type") {
      let c = 0;
      correctAnswer[questionType].forEach((x) => {
        if (x.answer === "") c = c + 1;
      });
      if (c > 0) {
        alert.error(`Please fill ${c} field`);
        setAuthorQuesContentLoader(false);
        return null;
      }
    }
    const question = {
      question: questionText,
      questionType: questionType,
      options: isFillUp
        ? inputList.map((x) => ({ optionId: x.optionId, value: "" }))
        : inputList,
      correctAnswers: correctAnswer,
      description: { assertion: assertText, reasoning: reasonText },
      visibilityStatus: visible,
      cognitive: cognitive,
      language,
    };

    if (assessmentType === "objective") {
      question.difficulty = difficulty;
    }

    if (assessmentType === "competency") {
      authorQuestionFormData.append("subjectId", subjectId);
      authorQuestionFormData.append("sectionId", sectionId);
    }

    chapterId &&
      authorQuestionFormData.append(
        "chapterId",
        !resources ? chapterId[0] : chapId,
      );
    if (topic.id) {
      topic.id && authorQuestionFormData.append("topicId", topic.id);
    } else {
      assessmentType !== "competency" &&
        topicId &&
        authorQuestionFormData.append("topicId", topicId);
    }

    authorQuestionFormData.append("question", JSON.stringify(question));
    setAuthorQuestionFormData(authorQuestionFormData);
    const URL =
      assessmentType === "competency"
        ? `${process.env.REACT_APP_ORIGIN}/api/v1/competency-questions`
        : `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${userDetails.userId}/sections/${sectionId}/subjects/${subjectId}/questions`;
    try {
      const response = await axios.post(URL, authorQuestionFormData, {
        headers: {
          // 'content-type': 'multipart/form-data',
          token: authToken,
        },
      });
      if (response.data.status === "success") {
        setAuthorQuestiontMessage("Question Added.");
        const newQuestion = response.data.data.question;
        newQuestion.creatorId = {
          name: userDetails.name,
        };
        setArrQues(newQuestion);
        if (checkreview) {
          setReviewQuestion((arr) => [
            ...arr,
            { ...response.data.data.question, marks: marks },
          ]);
        }
        setAuthorQuestionFormData(new FormData());
      }
    } catch (error) {
      console.log(error);
      if (error.response.data.status === "fail") {
        setAuthorQuestiontMessage(error.response.data.message);
      } else {
        setAuthorQuestiontMessage("Try Again.");
      }
    }
    setAuthorQuesContentLoader(false);
    setAuthorQuestionFormData(new FormData());
    setQuestionText("");
    setAssertText("");
    setReasonText("");
    setExplanation("");
    setQuestionType("Choose Question Type");
    setInputList([{ optionId: "", value: "" }]);
    setCorrectAnswer({});
    setCognitive("Cognitive");
    setDifficulty("Difficulty");
    setVisible("Visible To");
  };

  useEffect(() => {
    if (questionType !== "assertion-reasoning") return;
    const cAns = correctAnswer[questionType];
    if (!cAns) {
      setCorrectAnswer({
        [questionType]: { explanation },
      });
    } else {
      setCorrectAnswer({
        [questionType]: { ...cAns, explanation },
      });
    }
  }, [explanation]);

  return (
    <div className="container my-4">
      <>
        <div className="authorQues mb-3">
          <div className="row">
            <div className="col-md-8">
              {questionType === "assertion-reasoning" ? (
                <>
                  <QuestionInput
                    key={1}
                    text={assertText}
                    setText={setAssertText}
                    placeholder={"Write Assertion"}
                    uploadFile={uploadFile}
                    questionType={questionType}
                    imageName="assertImg"
                    disabled={questionType === "Choose Question Type"}
                    editor={true}
                  />
                  <QuestionInput
                    key={2}
                    text={reasonText}
                    setText={setReasonText}
                    placeholder={"Write reason"}
                    uploadFile={uploadFile}
                    questionType={questionType}
                    imageName="reasonImg"
                    editor={true}
                    disabled={questionType === "Choose Question Type"}
                  />
                </>
              ) : (
                <QuestionInput
                  text={questionText}
                  setText={setQuestionText}
                  placeholder={"Write question"}
                  uploadFile={uploadFile}
                  questionType={questionType}
                  imageName="questionImg"
                  disabled={questionType === "Choose Question Type"}
                  editor={questionType === "descriptive"}
                />
              )}
              {inputList.map((field, index) => (
                <FieldInput
                  index={index}
                  totalFields={inputList.length}
                  questionType={questionType}
                  type={
                    ["mcq", "correctstatement", "assertion-reasoning"].includes(
                      questionType,
                    )
                      ? "radio"
                      : "checkbox"
                  }
                  field={field}
                  handleCorrectInput={(e) => handleCorrectAnswer(e, index)}
                  handleInput={(id, name, value) =>
                    handleInputChange(index, id, name, value)
                  }
                  remove={() => handleRemoveClick(index)}
                  uploadFile={(e, optionId) => {
                    const file = e.target.files[0];
                    if (validateThumbnail(file)) {
                      authorQuestionFormData.append(optionId, file);
                      setAuthorQuestionFormData(authorQuestionFormData);
                      alert.success(`Image ${index + 1} Uploaded`);
                    } else {
                      e.target.value = null;
                      alert.error("Please select valid file");
                    }
                  }}
                />
              ))}
              {hideAddFieldButton ? null : (
                <button
                  type="button"
                  className="btn btn-add-option"
                  onClick={handleAddClick}
                >
                  <AddIcon className="ico-block" /> Add Option
                </button>
              )}

              {questionType === "assertion-reasoning" ? (
                <QuestionInput
                  text={explanation}
                  setText={setExplanation}
                  placeholder={"Write explanation"}
                  uploadFile={uploadFile}
                  questionType={questionType}
                  editor={true}
                />
              ) : null}
            </div>
            <div className="col-md-4">
              {assessmentType === "competency"?<DropdownMenu
                  list={{ hindi: "Hindi", english: "English" }}
                  placeholder={"Choose Language"}
                  selectedValue={language}
                  selectValue={(e) => setLanguage(e)}
                  
                />:null}
              <DropdownMenu
                list={questionTypes}
                placeholder={"Choose Type"}
                selectedValue={questionTypes[questionType]}
                selectValue={handleSelect1}
                isDisabled={assessmentType === "competency" && language ? false : true}
              />
              {assessmentType === "objective" ? (
                <>
                  <DropdownMenu
                    list={DIFFICULTY_LABELS}
                    placeholder={"Choose Difficulty"}
                    selectedValue={difficulty}
                    selectValue={handleSelect2}
                    disabled={
                      questionType && questionType != "Choose Question Type"
                        ? false
                        : true
                    }
                  />
                </>
              ) : null}
              <DropdownMenu
                list={COGNITIVE_LABELS}
                placeholder={"Choose Cognitive"}
                selectedValue={cognitive}
                selectValue={handleSelect3}
                disabled={
                  assessmentType === "competency"
                    ? false
                    : difficulty && difficulty != "Difficulty"
                    ? false
                    : true
                }
              />

              <DropdownMenu
                list={VISIBILITY_LABELS}
                placeholder={"Choose Visibility"}
                selectedValue={visible}
                selectValue={handleSelect4}
                disabled={
                  assessmentType === "competency"
                    ? false
                    : cognitive && cognitive != "Cognitive"
                    ? false
                    : true
                }
              />

              {topicsSel.length > 1 && (
                <Dropdown className="option-dropdown mb-3">
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="btn-question-type"
                    disabled={visible && visible != "Visible" ? false : true}
                  >
                    {topic.name}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="pra-dropdown edit-dropdown">
                    {isTopic &&
                      topicsSel?.map((x) => (
                        <Dropdown.Item
                          onSelect={() => {
                            setTopic({
                              ...topic,
                              ["name"]: x.name,
                              ["id"]: x.id,
                            });
                          }}
                          eventKey={x.name}
                          className="menu_option pra-drop-list edit_option"
                        >
                          {x.name}
                          <div>
                            <input type="radio" name="radio" />
                            <span></span>
                          </div>
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {authorQuesContentLoader ? (
                <div className="text-center">
                  <CircularProgress
                    style={{ color: "#FF075B", fontWeight: "600" }}
                  />
                </div>
              ) : (
                <button
                  type="button"
                  className="btn btn-add-option"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              )}
              {initial && handleRemoveClickCard && (
                <div className="opt-edit">
                  <span
                    className="round-btn"
                    onClick={() => handleRemoveClickCard(index)}
                  >
                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23 4H16V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0H11C10.2044 0 9.44129 0.316071 8.87868 0.87868C8.31607 1.44129 8 2.20435 8 3V4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2.09L3.64 21.5C3.76437 22.7376 4.34557 23.8844 5.27012 24.7165C6.19467 25.5486 7.39617 26.0062 8.64 26H15.4C16.6438 26.0062 17.8453 25.5486 18.7699 24.7165C19.6944 23.8844 20.2756 22.7376 20.4 21.5L21.91 6H23C23.2652 6 23.5196 5.89464 23.7071 5.70711C23.8946 5.51957 24 5.26522 24 5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM10 3C10 2.73478 10.1054 2.48043 10.2929 2.29289C10.4804 2.10536 10.7348 2 11 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V4H10V3ZM10.09 19H10C9.74966 19.001 9.50805 18.9081 9.3229 18.7396C9.13775 18.5711 9.02253 18.3393 9 18.09L8.48 12.09C8.45746 11.8248 8.54119 11.5615 8.71279 11.358C8.88439 11.1545 9.12978 11.0275 9.395 11.005C9.66022 10.9825 9.92353 11.0662 10.127 11.2378C10.3305 11.4094 10.4575 11.6548 10.48 11.92L11.01 17.92C11.0209 18.0514 11.0058 18.1837 10.9654 18.3092C10.925 18.4347 10.8602 18.551 10.7747 18.6514C10.6892 18.7518 10.5847 18.8343 10.4672 18.8941C10.3497 18.9539 10.2215 18.9899 10.09 19ZM15 18.09C14.9775 18.3393 14.8623 18.5711 14.6771 18.7396C14.4919 18.9081 14.2503 19.001 14 19H13.91C13.7785 18.9887 13.6505 18.9515 13.5334 18.8905C13.4164 18.8295 13.3126 18.7459 13.228 18.6445C13.1434 18.5432 13.0797 18.4261 13.0405 18.3001C13.0014 18.174 12.9876 18.0414 13 17.91L13.53 11.91C13.5525 11.6448 13.6795 11.3994 13.883 11.2278C14.0865 11.0562 14.3498 10.9725 14.615 10.995C14.8802 11.0175 15.1256 11.1445 15.2972 11.348C15.4688 11.5515 15.5525 11.8148 15.53 12.08L15 18.09Z"
                        fill="#0F93A8"
                      />
                    </svg>
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        {authorQuestiontMessage && (
          <div className="text-center">
            <p style={{ color: "#FF075B", fontWeight: "600" }}>
              {authorQuestiontMessage}
            </p>
          </div>
        )}
      </>
    </div>
  );
}
